import { render, staticRenderFns } from "./AnalysisDetail.vue?vue&type=template&id=6613ff37&scoped=true&"
import script from "./AnalysisDetail.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AnalysisDetail.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AnalysisDetail.vue?vue&type=style&index=0&id=6613ff37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6613ff37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6613ff37')) {
      api.createRecord('6613ff37', component.options)
    } else {
      api.reload('6613ff37', component.options)
    }
    module.hot.accept("./AnalysisDetail.vue?vue&type=template&id=6613ff37&scoped=true&", function () {
      api.rerender('6613ff37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Analyses/components/AnalysisCard/components/AnalysisDetail.vue"
export default component.exports